import { getLocaleVariable } from '@lib/environment'
import { type Locale } from '@lib/language'
import { type ShopifyHeaders } from './types'

const shopifyApiVersion = '2025-04'

/**
 * Gets Shopify domain.
 */
export const getShopifyDomain = (locale: Locale) => {
  const storeId = getLocaleVariable(locale, 'NEXT_PUBLIC_SHOPIFY_STORE_ID')

  if (!storeId) {
    return
  }

  return `${storeId}.myshopify.com`
}

/**
 * Gets Shopify Storefront API URL.
 */
export const getShopifyStorefrontApiUrl = (shopifyDomain: string): string => {
  return `https://${shopifyDomain}/api/${shopifyApiVersion}`
}

/**
 * Gets Shopify Admin API URL.
 */
export const getShopifyAdminApiUrl = (shopifyDomain: string): string => {
  return `https://${shopifyDomain}/admin/api/${shopifyApiVersion}`
}

/**
 * Gets Shopify headers with access token.
 */
export const getShopifyHeaders = (locale: Locale): ShopifyHeaders => {
  const apiPassword = getLocaleVariable(locale, 'SHOPIFY_API_PASSWORD')

  return {
    'Content-Type': 'application/json',
    'Accept-Encoding': 'gzip,deflate,compress',
    'X-Shopify-Access-Token': apiPassword ?? '',
  }
}
